import React from 'react';
import Navbar from '../components/Navbar';

const Security = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Security</h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Commitment to Security</h2>
            <p className="text-gray-600 mb-6">
              At MTClicks, we take the security of your data and our services seriously. We implement 
              industry-standard security measures to protect your information and ensure the integrity 
              of our digital marketing solutions.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Data Protection</h3>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• End-to-end encryption for all data transmissions</li>
              <li>• Secure SSL certificates on all our platforms</li>
              <li>• Regular security audits and penetration testing</li>
              <li>• Compliance with industry security standards</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Infrastructure Security</h3>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• 24/7 monitoring of our systems and networks</li>
              <li>• Automated backup systems with multiple redundancies</li>
              <li>• Secure cloud hosting with enterprise-grade protection</li>
              <li>• Regular security updates and patch management</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Access Control</h3>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• Multi-factor authentication for all accounts</li>
              <li>• Role-based access control systems</li>
              <li>• Regular access reviews and permission audits</li>
              <li>• Secure password policies and requirements</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Incident Response</h3>
            <p className="text-gray-600 mb-4">
              We have a comprehensive incident response plan in place to quickly address any security 
              concerns. Our security team is available 24/7 to respond to potential threats and 
              minimize any impact on our services.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Reporting Security Issues</h3>
            <p className="text-gray-600 mb-4">
              If you discover a security vulnerability or have concerns about our security practices, 
              please contact us immediately at:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg mb-6">
              <p className="text-gray-800 font-medium">Security Team: security@mtclicks.com</p>
              <p className="text-gray-600">Response time: Within 24 hours</p>
            </div>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Compliance</h3>
            <p className="text-gray-600 mb-6">
              MTClicks complies with relevant data protection regulations including GDPR, CCPA, 
              and other applicable privacy laws. We regularly review and update our security 
              practices to maintain the highest standards of protection.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
              <p className="text-blue-800">
                <strong>Last Updated:</strong> This security policy was last updated on January 1, 2025.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
